<template>
  <div class="root-box">
    <el-card shadow="never" class="llm-card">
      <div slot="header">AI 模型</div>
      <el-form label-width="90px" :size="size" style="max-width: 640px">
        <el-form-item label="模型地址">
          <el-input v-model="llm.baseUrl" placeholder="https://api.example.com/v1" />
        </el-form-item>
        <el-form-item label="模型名">
          <el-input v-model="llm.model" placeholder="模型名称" />
        </el-form-item>
        <el-form-item label="密钥">
          <el-input v-model="llm.apiKey" show-password placeholder="留空则不修改" />
          <div v-if="llm.apiKeyMask" class="mask">当前：{{ llm.apiKeyMask }}</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="llmSaving" @click="saveLlm">保存</el-button>
          <el-button :loading="llmTesting" @click="testLlm">测试模型</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="op-box">
      <el-button type="primary" :size="size" @click="toggleBaiduKey">一键切换百度Key</el-button>
      <span v-if="baiduKeyItem" class="current-key">当前值：{{ baiduKeyItem.valueField }}</span>
    </div>

    <el-table :data="list" border stripe max-height="800">
      <el-table-column label="序号" type="index" show-overflow-tooltip width="50"></el-table-column>
      <el-table-column prop="keyField" label="参数名"></el-table-column>

      <el-table-column prop="description" label="参数描述"></el-table-column>

      <el-table-column label="开关">
        <template slot-scope="scope">
          <el-switch
            v-if="scope.row.type === 1"
            :value="scope.row.valueField"
            @change="(e) => change(e, scope.row)"
            active-text="开启"
            active-value="1"
            inactive-text="关闭"
          ></el-switch>

          <div v-if="scope.row.type === 2">
            <el-input-number size="small" disabled :value="scope.row.valueField"></el-input-number>

            <span style="margin-left: 20px">
              <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            </span>
          </div>

          <div v-if="scope.row.type === 3">
            <el-input
              size="small"
              style="width: 180px"
              disabled
              :value="scope.row.valueField"
            ></el-input>

            <span style="margin-left: 20px">
              <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
              <el-button
                v-if="scope.row.keyField === BAIDU_KEY_FIELD"
                type="text"
                size="small"
                @click="toggleBaiduKey"
              >一键切换</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :visible.sync="visible"
      width="600px"
      max-height="600"
      title="修改配置信息"
      :close-on-click-modal="false"
    >
      <el-form ref="from" :model="form" :size="size">
        <el-form-item :label="form.description" prop="valueField">
          <el-input-number
            v-if="form.type === 2"
            v-model="form.valueField"
            style="width: 200px"
          ></el-input-number>

          <el-input
            v-if="form.type === 3"
            v-model="form.valueField"
            style="width: 200px"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="save">保存</el-button>
        <el-button type="info" :size="size" @click="visible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { getLlmSetting, getSystemSetting, saveLlmSetting, testLlmSetting } from "@/api";

const BAIDU_KEY_FIELD = "BAIDU_KEY";
const BAIDU_KEY_A = "KEY:WzYc9EDFDjJcEDaZvxGFXuo";
const BAIDU_KEY_B = "nuvVJ7y6wzP8LC0nnAC2jVVGu0uUDFVv";

export default {
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    }),
    baiduKeyItem() {
      return this.list.find((row) => row.keyField === BAIDU_KEY_FIELD) || null;
    }
  },
  data() {
    return {
      visible: false,
      list: [],
      form: {},
      BAIDU_KEY_FIELD,
      llmSaving: false,
      llmTesting: false,
      llm: {
        baseUrl: "",
        model: "",
        apiKey: "",
        apiKeyMask: ""
      }
    };
  },
  created() {
    this.query();
    this.loadLlm();
  },
  methods: {
    query() {
      getSystemSetting().then((res) => {
        this.list = res.data || [];
      });
    },

    loadLlm() {
      getLlmSetting().then((res) => {
        const data = res.data || {};
        this.llm = {
          baseUrl: data.baseUrl || "",
          model: data.model || "",
          apiKey: "",
          apiKeyMask: data.apiKeyMask || ""
        };
      });
    },

    saveLlm() {
      this.llmSaving = true;
      saveLlmSetting({
        baseUrl: this.llm.baseUrl,
        model: this.llm.model,
        apiKey: this.llm.apiKey
      }).then((res) => {
        const data = res.data || {};
        this.llm.apiKey = "";
        this.llm.apiKeyMask = data.apiKeyMask || "";
        this.$message.success("已保存");
      }).finally(() => {
        this.llmSaving = false;
      });
    },

    testLlm() {
      this.llmTesting = true;
      testLlmSetting({
        baseUrl: this.llm.baseUrl,
        model: this.llm.model,
        apiKey: this.llm.apiKey
      }).then((res) => {
        this.$message.success("模型可用：" + (res.data || "OK"));
      }).finally(() => {
        this.llmTesting = false;
      });
    },

    toggleBaiduKey() {
      const item = this.baiduKeyItem;
      if (!item) {
        this.$message.warning("未找到 BAIDU_KEY 配置");
        return;
      }
      const current = item.valueField;
      let next;
      if (current === BAIDU_KEY_A) {
        next = BAIDU_KEY_B;
      } else if (current === BAIDU_KEY_B) {
        next = BAIDU_KEY_A;
      } else {
        this.$message.warning(`当前 BAIDU_KEY 不是预设值，无法切换：${current}`);
        return;
      }
      this.$confirm(`确认将 BAIDU_KEY 切换为「${next}」吗?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const param = _.cloneDeep(item);
        param.valueField = next;
        this.$http.post("/admin/setting/system/modify", param).then(() => {
          this.$message.success("切换成功");
          this.query();
        });
      });
    },

    change(value, item) {
      const msg = value ? "开启" : "关闭";
      this.$confirm(`确认${msg}吗?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const url = `/admin/setting/system/modify`;
        const param = _.cloneDeep(item);
        param.valueField = value ? "1" : "0";
        this.$http.post(url, param).then(() => {
          this.$message.success("操作成功");
          this.query();
        });
      });
    },

    save() {
      const url = `/admin/setting/system/modify`;
      this.$http.post(url, this.form).then(() => {
        this.$message.success("操作成功");
        this.query();
        this.visible = false;
      });
    },
    openEdit(row) {
      this.form = _.cloneDeep(row);
      this.visible = true;
    }
  }
};
</script>

<style scoped lang="less">
.core {
  margin: 20px 0;
  width: 120px;
}

.llm-card {
  margin-bottom: 16px;
}

.mask {
  color: #909399;
  font-size: 12px;
}

.op-box {
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  .current-key {
    margin-left: 12px;
    font-size: 13px;
    color: #606266;
  }
}
</style>
